import styled from '@emotion/styled';
import { Button, TextBox, Typography, Skeleton } from 'src/components-dummy';
import { AutoCompleteForm } from '../../../../VisualEditor/components/AutoComplete';

export const CampaignPreviewContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.custom['gray-90']};
  padding: 0 32px;
  overflow-y: auto;
  height: 100vh;
`;

export const PreviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0;
  color: ${({ theme }) => theme.palette.custom['gray-10']};
  border-bottom: 1px solid ${({ theme }) => theme.palette.custom['gray-60']};
`;

export const PreviewSkuStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconsContainer = styled.div`
  display: flex;
  gap: 4px;
`;

export const ButtonIconStyled = styled(Button)<{ active: boolean }>`
  background: transparent;
  min-width: 36px;
  background-color: ${({ active, theme }) => active && theme.palette.custom['primary-90']};

  & > span {
    margin-right: unset !important;
  }

  svg {
    path {
      fill: ${({ theme }) => theme.palette.custom['gray-50']};
    }
  }
`;

export const TextBoxStyled = styled(TextBox)`
  .input-base-wrapper {
    border: transparent;
    background: ${({ theme }) => theme.palette.custom['gray-80']};
  }
`;

export const PreviewContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 56px 0 124px 0;
`;

export const EmptyCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.custom['gray-70']};
  padding: 32px;
`;

export const EmptyHeaderStyled = styled(Typography)`
  color: ${({ theme }) => theme.palette.custom['gray-10']};
  margin-bottom: 32px;
`;

export const ImagesRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const ImageStyled = styled.img`
  width: 176px;
  height: 325px;
`;

export const SkeletonHeader = styled.div`
  width: 40%;
  margin-bottom: 32px;
`;

export const ImageSkeleton = styled(Skeleton)`
  width: 176px;
  height: 325px;
  border-radius: 4px;
`;

export const AutoCompleteFormStyled = styled(AutoCompleteForm)`
  width: 350px;
`;
